import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const OccupancyIcon16 = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M8.00004 7.33333C9.4728 7.33333 10.6667 6.13943 10.6667 4.66667C10.6667 3.19391 9.4728 2 8.00004 2C6.52728 2 5.33337 3.19391 5.33337 4.66667C5.33337 6.13943 6.52728 7.33333 8.00004 7.33333ZM8.00004 6.33333C8.92052 6.33333 9.66671 5.58714 9.66671 4.66667C9.66671 3.74619 8.92052 3 8.00004 3C7.07957 3 6.33337 3.74619 6.33337 4.66667C6.33337 5.58714 7.07957 6.33333 8.00004 6.33333Z'
    fill='#3379BD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M4.00004 14C5.4728 14 6.66671 12.8061 6.66671 11.3333C6.66671 9.86057 5.4728 8.66667 4.00004 8.66667C2.52728 8.66667 1.33337 9.86057 1.33337 11.3333C1.33337 12.8061 2.52728 14 4.00004 14ZM4.00004 13C4.92052 13 5.66671 12.2538 5.66671 11.3333C5.66671 10.4129 4.92052 9.66667 4.00004 9.66667C3.07957 9.66667 2.33337 10.4129 2.33337 11.3333C2.33337 12.2538 3.07957 13 4.00004 13Z'
    fill='#3379BD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M14.6667 11.3333C14.6667 12.8061 13.4728 14 12 14C10.5273 14 9.33337 12.8061 9.33337 11.3333C9.33337 9.86057 10.5273 8.66667 12 8.66667C13.4728 8.66667 14.6667 9.86057 14.6667 11.3333ZM13.6667 11.3333C13.6667 12.2538 12.9205 13 12 13C11.0796 13 10.3334 12.2538 10.3334 11.3333C10.3334 10.4129 11.0796 9.66667 12 9.66667C12.9205 9.66667 13.6667 10.4129 13.6667 11.3333Z'
    fill='#3379BD'
  />
</Svg>;

export default OccupancyIcon16;
